exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (768px) {\n  .calendar {\n    max-width: 320px;\n  }\n}\n.calendar .DayPicker-WeekdaysRow, .calendar .DayPicker-Week {\n  max-width: 320px;\n}\n.calendar .DayPicker-Weekday, .calendar .DayPicker-Day {\n  width: 42px;\n}\n@media screen and (min-width: 1200px) {\n  .calendar .DayPicker-Weekday, .calendar .DayPicker-Day {\n    width: 45px;\n  }\n}", ""]);

// exports
